import { useContext } from 'react';
import { AuthContext } from '../index';
import { generateContextNotFoundError } from '@/context/utils';

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw generateContextNotFoundError('useAuth');
  }
  return context;
}
